import moment from "moment";
import React from "react";
import { MdAdd } from "react-icons/md";
import { Spinner } from "react-rainbow-components";
import styled from "styled-components";
import { GetErrorMessage } from "../../functions/error";
import { ICoupon } from "../../interfaces/coupon";
import { IUser } from "../../interfaces/user";
import { getCouponWithCouponId } from "../../services/coupon.service";
import { useError } from "../../store/ErrorModal";
import ModalAddUserCodeCoupon from "./ModalAddUserCodeCoupon";
import ModalCreateCodeCoupon from "./ModalCreateCodeCoupon";
const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;
const Title = styled.h5`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;

const DescriptionContainer = styled.div`
  max-height: 4.5rem;
  overflow-y: scroll;
`;
const ListCodeContainer = styled.div`
  background-color: #f8f9fd;
  border-radius: 0.5rem;
  padding: 0.5rem;
  flex: 1;
  overflow-y: scroll;
  position: relative;
`;

const AddCouponButton = styled.div`
  position: absolute;
  bottom: 3.5rem;
  right: 4rem;
  padding: 0.5rem;
  background: #fff;
  box-shadow: 20px 20px 60px #bebebe, -20px -20px 60px #ffffff;
  border-radius: 999rem;
  width: 40px;
  cursor: pointer;
  transition: all 0.5s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  height: 40px;
  text-overflow: hidden;
  &:hover {
    transition: all 0.5s ease;
    transform: scale(1.5);
  }
`;
const CardCode = styled.div`
  padding: 0.5rem;
  margin-bottom: 0.25rem;
  background-color: #ffffff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  > div {
    display: flex;
    > h5 {
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
      flex: 1;
      height: fit-content;
    }
    > p {
      color: #e74c3c;
    }
  }
  > p {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin: 0;
  }
`;
interface Props {
  coupon: ICoupon;
  allUser: IUser[] | undefined;
}

interface ICodeCoupon {
  uid?: string;
  user?: IUser;
  couponId: string;
  codeCoupon: string;
  expiresDate: string | number | Date;
  isUsed?: boolean;
}

const CouponDetail = (props: Props) => {
  const { coupon } = props;
  const [dataCoupon, setDataCoupon] = React.useState<ICodeCoupon[]>();
  const [isLoading, setIsLoading] = React.useState<boolean>();
  const [showCreateCodeCoupon, setShowCreateCodeCoupon] =
    React.useState<boolean>(false);
  const [showAddUserCoupon, setShowAddUserCoupon] =
    React.useState<boolean>(false);
  const [codeFocus, setCodeFocus] = React.useState<string>();
  const { onError } = useError();
  const fetchData = React.useCallback(async () => {
    setDataCoupon([]);
    const couponId = coupon.couponId;
    setIsLoading(true);
    let result;
    try {
      result = await getCouponWithCouponId(couponId);
    } catch (error) {
      setIsLoading(false);
      return onError(GetErrorMessage(error));
    }
    const data = result?.data as ICodeCoupon[];
    if (data.length === 0) return setIsLoading(false);
    const hUser: ICodeCoupon[] = [];
    const dUser: ICodeCoupon[] = [];
    data.forEach((item) => {
      if (item.user) return hUser.push(item);
      return dUser.push(item);
    });
    setDataCoupon([...dUser, ...hUser]);
    setIsLoading(false);
  }, [coupon.couponId, onError]);
  React.useEffect(() => {
    fetchData();
  }, [coupon, fetchData]);
  return (
    <Container>
      <Title>{coupon.productName}</Title>
      <DescriptionContainer>
        <p className="text-h-color">{coupon.productDescription}</p>
      </DescriptionContainer>
      <ListCodeContainer>
        {!isLoading ? (
          dataCoupon?.map((item) => (
            <CardCode key={item.codeCoupon}>
              <div style={{ display: "flex" }}>
                <h5>{item.codeCoupon}</h5>
                {item.isUsed && <p>ใช้แล้ว</p>}
              </div>
              {item.user ? (
                <p>{`${item.user.firstName} ${item.user.lastName}`}</p>
              ) : (
                <p
                  className="text-h-color"
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                  onClick={() => {
                    setCodeFocus(item.codeCoupon);
                    setShowAddUserCoupon(true);
                  }}
                >
                  เพิ่มผู้ใช้งาน
                </p>
              )}
              <p className="text-h-color">
                วันหมดอายุ: {moment(item.expiresDate).format("DD/MM/YYYY")}
              </p>
            </CardCode>
          ))
        ) : (
          <Spinner />
        )}
      </ListCodeContainer>
      <AddCouponButton onClick={() => setShowCreateCodeCoupon(true)}>
        <MdAdd size={32} color="#555" />
      </AddCouponButton>
      <ModalCreateCodeCoupon
        fetchData={fetchData}
        isOpen={showCreateCodeCoupon}
        couponId={coupon.couponId}
        onRequestClose={() => setShowCreateCodeCoupon(false)}
      />
      <ModalAddUserCodeCoupon
        users={props.allUser}
        isOpen={showAddUserCoupon}
        codeFocus={codeFocus}
        onRequestClose={() => setShowAddUserCoupon(false)}
        fetchData={fetchData}
      />
    </Container>
  );
};

export default CouponDetail;
